module.exports = __webpack_public_path__ + "static/media/token-logo.a1fe4f62.svg";